import * as React from "react";
import { Link } from "react-router-dom";

export interface Props {
  selectedReport: string;
}

function HelpButton({ selectedReport }: Props) {
  return (
    <Link
      to={`/historical/help/${selectedReport}`}
      className="ds-u-float--right ds-u-padding-top--1"
      target="_blank"
    >
      Help
    </Link>
  );
}

export default HelpButton;
